<template>
  <div>
    <div class="page f-pr">
      <img src="../assets/zs3.png" alt="">

      <div class="page1-info">
        <div class="title fc" style="font-weight: bold;">
          <span>
            尊敬的
          </span>
          <span class="name">
            {{ userInfo.realname }}
          </span>
          <span>
            国粉
          </span>
        </div>
        <div class="p">
          感谢您对“国宝李渡农庄文化共建、非遗传承与乡村振兴”的积极参与和热忱付出!
        </div>
        <div class="p">
          国宝李渡农庄以“助力国宝申遗,共享田园时光”为核心理念,依托元代古窖池与非遗酿造技艺,打造“酒文旅+生态农庄”融合新模式。您通过以下行动,为守护文化遗产、赋能乡村发展贡献了重要力量:
        </div>
        
        <div class="p">
          1.认领共享菜地,践行绿色农耕与生态循环
        </div>
        
        <div class="p">
          2.认养家禽助力乡村养殖经济,见证"从农场到餐桌"的可持续实践
        </div>
        
        <div class="p">
          3.积极参与农庄活动（播种节/丰收节/主题派对）,传播李渡酒文化与农耕精神
        </div>
        
        <div class="p">
          4.以创意与行动支持中国白酒申遗,共建“酒香农庄”文化IP
        </div>
        
        <div class="p">
          特颁此证,铭记您与国宝李渡共同书写“酿一方美酒,守一方沃土”的乡村振兴篇章。
        </div>


      </div>
      <div class="gz">
        <div>颁发单位:国宝李渡</div>
        <div>树苗编号:{{ userInfo.userNo }} </div>
        <!-- <div>颁发日期:2025年3月9日</div> -->
      </div>
      <van-overlay :show="showLoading">
        <div class="fcc-h " style="height: 100vh;">
          <van-loading size="24px" vertical color="#fff">加载中...</van-loading>
        </div>
      </van-overlay>


    </div>
  </div>
</template>

<script>

import { login } from "@/api/api";

export default {


  data() {
    return {
      showLoading: false,
      userInfo: {}
    }
  },

  async mounted() {
    let self = this
    // self.showLoading = true
    this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
    if(this.userInfo && !this.userInfo.username){
      self.$router.push({ path: '/index1' })
    }
    login({username:this.userInfo.username}).then(res => {
      if (res.status != 200) {
        this.$toast(res.msg)
        self.$router.push({ path: '/index1' })
        return
      } else {
        window.localStorage.setItem('userInfo', JSON.stringify(res.data.userInfo))
        self.userInfo = res.data.userInfo
        self.$forceUpdate()
      }
    }).finally(f => {
      self.showLoading = false
    })

  },



}

</script>
<style scoped lang="less">
.page {
  display: block;

  min-height: 100vh;
  background: #D6F9D8;
  background-size: 100% auto;
  // background-size: cover;
  position: relative;

  >img {
    display: block;
    width: 100%;
  }
}



.page1-info {
  position: absolute;
  left: 66px;
  right: 66px;
  top: 268px;

  font-weight: 300;
  font-size: 24px;
  color: #000000;
  line-height: 48px;

  .name {
    padding: 0 10px;
    border-bottom: 1px solid #000;
    margin-bottom: 10px;
  }

  .p {
    text-indent: 2em;

    font-weight: 300;
    font-size: 22px;
    color: #000000;
    line-height: 48px;
  }
}

.gz {
  font-weight: 400;
  font-size: 24px;
  color: #000000;
  line-height: 50px;
  position: absolute;
  right: 66px;
  top: 958px;
  height: 245px;
  width: 250px;
  padding-top: 52px;
  background: url(../assets/z.png) 5px 0 no-repeat;
  background-size: 245px 245px;


}
</style>